
const firebaseConfig = {
    apiKey: "AIzaSyATOx7dckOfekQqTT9lZ17tr8BInvWbhH4",
    authDomain: "mustafiz-healthcare-firebase.firebaseapp.com",
    projectId: "mustafiz-healthcare-firebase",
    storageBucket: "mustafiz-healthcare-firebase.appspot.com",
    messagingSenderId: "631435667075",
    appId: "1:631435667075:web:d112b4e37f988376cd5db6"
};

export default firebaseConfig;